import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { getFormattedCellValue, tableStyles } from './details-table-helpers';

interface BasicTableProps {
    value: any;
    label?: string;
}

const BasicTableRow = ({
    label,
    value,
}: BasicTableProps): React.JSX.Element => {
    return (
        <TableRow key={label}>
            {label && <TableCell sx={tableStyles.colorKey}>{label}</TableCell>}
            <TableCell sx={tableStyles.colorValue}>
                {getFormattedCellValue(value)}
            </TableCell>
        </TableRow>
    );
};

export default BasicTableRow;
